function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.752 1.50439H2.25195C1.42695 1.50439 0.751953 2.17939 0.751953 3.00439V12.0044C0.751953 12.8294 1.42695 13.5044 2.25195 13.5044H7.50195L6.00195 15.7544V16.5044H12.002V15.7544L10.502 13.5044H15.752C16.577 13.5044 17.252 12.8294 17.252 12.0044V3.00439C17.252 2.17939 16.577 1.50439 15.752 1.50439ZM15.752 10.5044H2.25195V3.00439H15.752V10.5044Z",
    fill: "#666666",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopWhite);
export default __webpack_public_path__ + "static/media/desktop-white.ef472b4ba6b345118f772f9f2e3f7f9f.svg";
export { ForwardRef as ReactComponent };